import {useMutation} from "@tanstack/react-query"
import {API} from "config"
import moment from "moment";

const useExportReportType = () => {
    return useMutation({
        mutationFn: async ({reportType, exportMine, startDate, endDate}) => {
            const response = await API.get(`/reports/${reportType}/${exportMine}/export`, {
                params: {
                    init: moment(startDate).unix(),
                    end: moment(endDate).unix()
                },
                responseType: 'blob'
            });

            return { data: response.data, exportMine };
        },
        onSuccess: ({ data, exportMine }) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', `relatorio-financeiro-${moment().format('YYYY-MM-DD')}.${exportMine}`);
            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    })
}

export default useExportReportType